export default "__VITE_ASSET__CJ1NF_dH__"